module.exports = __webpack_public_path__ + "img/ducgq.7852cc42.png";